// extracted by mini-css-extract-plugin
export var avatarBack = "sidebar-module--avatarBack--7f6b1";
export var avatarFace = "sidebar-module--avatarFace--51d8b";
export var avatarFlip = "sidebar-module--avatarFlip--d83ea";
export var avatarFlipInner = "sidebar-module--avatarFlipInner--97b26";
export var badge = "sidebar-module--badge--c066a";
export var badgeGray = "sidebar-module--badgeGray--f3fbf";
export var boxContent = "sidebar-module--boxContent--93ec2";
export var boxName = "sidebar-module--boxName--c5e67";
export var contactBlock = "sidebar-module--contactBlock--29c3d";
export var contactBlockItem = "sidebar-module--contactBlockItem--c2159";
export var content = "sidebar-module--content--342d4";
export var flipped = "sidebar-module--flipped--58e9b";
export var iconButton = "sidebar-module--iconButton--24aa1";
export var iconButtonCol = "sidebar-module--iconButtonCol--23616";
export var infoListItem = "sidebar-module--infoListItem--7c022";
export var name = "sidebar-module--name--a3720";
export var profileAvatar = "sidebar-module--profileAvatar--8c178";
export var resumeDownload = "sidebar-module--resumeDownload--93883";
export var rsBadgeBlue = "sidebar-module--rs-badge-blue--c4c21";
export var rsBadgeContent = "sidebar-module--rs-badge-content--27473";
export var rsBadgeCyan = "sidebar-module--rs-badge-cyan--3cf0a";
export var rsBadgeGreen = "sidebar-module--rs-badge-green--4622d";
export var rsBadgeIndependent = "sidebar-module--rs-badge-independent--6e992";
export var rsBadgeOrange = "sidebar-module--rs-badge-orange--a9a0a";
export var rsBadgeRed = "sidebar-module--rs-badge-red--af235";
export var rsBadgeViolet = "sidebar-module--rs-badge-violet--5b6ac";
export var rsBadgeYellow = "sidebar-module--rs-badge-yellow--11b1c";
export var rsBtnBlue = "sidebar-module--rs-btn-blue--7164a";
export var rsBtnCyan = "sidebar-module--rs-btn-cyan--2028e";
export var rsBtnGreen = "sidebar-module--rs-btn-green--306db";
export var rsBtnOrange = "sidebar-module--rs-btn-orange--8797e";
export var rsBtnRed = "sidebar-module--rs-btn-red--2db0b";
export var rsBtnViolet = "sidebar-module--rs-btn-violet--93ef0";
export var rsBtnYellow = "sidebar-module--rs-btn-yellow--71130";
export var rsFlexBoxGridItem1 = "sidebar-module--rs-flex-box-grid-item-1--1f3d7";
export var rsFlexBoxGridItem10 = "sidebar-module--rs-flex-box-grid-item-10--0119e";
export var rsFlexBoxGridItem11 = "sidebar-module--rs-flex-box-grid-item-11--acc23";
export var rsFlexBoxGridItem12 = "sidebar-module--rs-flex-box-grid-item-12--9ae79";
export var rsFlexBoxGridItem13 = "sidebar-module--rs-flex-box-grid-item-13--48436";
export var rsFlexBoxGridItem14 = "sidebar-module--rs-flex-box-grid-item-14--9578b";
export var rsFlexBoxGridItem15 = "sidebar-module--rs-flex-box-grid-item-15--c6299";
export var rsFlexBoxGridItem16 = "sidebar-module--rs-flex-box-grid-item-16--59c7a";
export var rsFlexBoxGridItem17 = "sidebar-module--rs-flex-box-grid-item-17--f6b70";
export var rsFlexBoxGridItem18 = "sidebar-module--rs-flex-box-grid-item-18--ada1a";
export var rsFlexBoxGridItem19 = "sidebar-module--rs-flex-box-grid-item-19--e8576";
export var rsFlexBoxGridItem2 = "sidebar-module--rs-flex-box-grid-item-2--e9757";
export var rsFlexBoxGridItem20 = "sidebar-module--rs-flex-box-grid-item-20--6e000";
export var rsFlexBoxGridItem21 = "sidebar-module--rs-flex-box-grid-item-21--7c13f";
export var rsFlexBoxGridItem22 = "sidebar-module--rs-flex-box-grid-item-22--46e35";
export var rsFlexBoxGridItem23 = "sidebar-module--rs-flex-box-grid-item-23--1cde1";
export var rsFlexBoxGridItem24 = "sidebar-module--rs-flex-box-grid-item-24--65b25";
export var rsFlexBoxGridItem3 = "sidebar-module--rs-flex-box-grid-item-3--6ff9c";
export var rsFlexBoxGridItem4 = "sidebar-module--rs-flex-box-grid-item-4--c4b32";
export var rsFlexBoxGridItem5 = "sidebar-module--rs-flex-box-grid-item-5--3586e";
export var rsFlexBoxGridItem6 = "sidebar-module--rs-flex-box-grid-item-6--934af";
export var rsFlexBoxGridItem7 = "sidebar-module--rs-flex-box-grid-item-7--e99ba";
export var rsFlexBoxGridItem8 = "sidebar-module--rs-flex-box-grid-item-8--6c4e8";
export var rsFlexBoxGridItem9 = "sidebar-module--rs-flex-box-grid-item-9--fa040";
export var rsFlexBoxGridItemOrder1 = "sidebar-module--rs-flex-box-grid-item-order-1--72408";
export var rsFlexBoxGridItemOrder10 = "sidebar-module--rs-flex-box-grid-item-order-10--63e75";
export var rsFlexBoxGridItemOrder11 = "sidebar-module--rs-flex-box-grid-item-order-11--c71e5";
export var rsFlexBoxGridItemOrder12 = "sidebar-module--rs-flex-box-grid-item-order-12--0120a";
export var rsFlexBoxGridItemOrder13 = "sidebar-module--rs-flex-box-grid-item-order-13--7f37e";
export var rsFlexBoxGridItemOrder14 = "sidebar-module--rs-flex-box-grid-item-order-14--dfb08";
export var rsFlexBoxGridItemOrder15 = "sidebar-module--rs-flex-box-grid-item-order-15--d170d";
export var rsFlexBoxGridItemOrder16 = "sidebar-module--rs-flex-box-grid-item-order-16--38917";
export var rsFlexBoxGridItemOrder17 = "sidebar-module--rs-flex-box-grid-item-order-17--ac68d";
export var rsFlexBoxGridItemOrder18 = "sidebar-module--rs-flex-box-grid-item-order-18--d5fde";
export var rsFlexBoxGridItemOrder19 = "sidebar-module--rs-flex-box-grid-item-order-19--80483";
export var rsFlexBoxGridItemOrder2 = "sidebar-module--rs-flex-box-grid-item-order-2--38e4e";
export var rsFlexBoxGridItemOrder20 = "sidebar-module--rs-flex-box-grid-item-order-20--9ae63";
export var rsFlexBoxGridItemOrder21 = "sidebar-module--rs-flex-box-grid-item-order-21--70552";
export var rsFlexBoxGridItemOrder22 = "sidebar-module--rs-flex-box-grid-item-order-22--9fc04";
export var rsFlexBoxGridItemOrder23 = "sidebar-module--rs-flex-box-grid-item-order-23--6216d";
export var rsFlexBoxGridItemOrder24 = "sidebar-module--rs-flex-box-grid-item-order-24--9ea19";
export var rsFlexBoxGridItemOrder3 = "sidebar-module--rs-flex-box-grid-item-order-3--edf16";
export var rsFlexBoxGridItemOrder4 = "sidebar-module--rs-flex-box-grid-item-order-4--a2e35";
export var rsFlexBoxGridItemOrder5 = "sidebar-module--rs-flex-box-grid-item-order-5--44255";
export var rsFlexBoxGridItemOrder6 = "sidebar-module--rs-flex-box-grid-item-order-6--e7ccd";
export var rsFlexBoxGridItemOrder7 = "sidebar-module--rs-flex-box-grid-item-order-7--3c9c4";
export var rsFlexBoxGridItemOrder8 = "sidebar-module--rs-flex-box-grid-item-order-8--4e5f2";
export var rsFlexBoxGridItemOrder9 = "sidebar-module--rs-flex-box-grid-item-order-9--ce9e0";
export var rsTagBlue = "sidebar-module--rs-tag-blue--de253";
export var rsTagCyan = "sidebar-module--rs-tag-cyan--f6162";
export var rsTagGreen = "sidebar-module--rs-tag-green--91b29";
export var rsTagOrange = "sidebar-module--rs-tag-orange--e2652";
export var rsTagRed = "sidebar-module--rs-tag-red--0cbf1";
export var rsTagViolet = "sidebar-module--rs-tag-violet--ebff7";
export var rsTagYellow = "sidebar-module--rs-tag-yellow--7cff6";
export var rsThemeDark = "sidebar-module--rs-theme-dark--56fe6";
export var rsThemeHighContrast = "sidebar-module--rs-theme-high-contrast--10034";
export var sideBar404Radius = "sidebar-module--sideBar404Radius--6d6fe";
export var sidebarContent = "sidebar-module--sidebarContent--643ff";